import React, { useCallback, useContext, useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { OrderItem } from "./Sales/OrderItem";
import { SellerConfirmationDialog } from "./Sales/SellerConfirmationDialog";
import { useQueryOrders } from "../../queries/order/hooks/useQueryOrders";
import { CircularProgress, Divider, Grid, TextField, debounce } from "@mui/material";
import { UserContext } from "../../hooks/userContext";
import { OrderType } from "../../constants/order";
import { SuccessOrderDialog } from "./Sales/SuccessOrderDialog";
import { useQueryBankAccount } from "../../queries/pharmacy/hooks/useQueryBankAccount";
import { ToasterContext } from "../../components/shared/Toaster/ToasterContext";
import { NotificationType } from "../../constants/global";
import { routeConfigs } from "../../navigation/routeConfig";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export const OpenOrders: React.FunctionComponent = () => {
  const { id }: any = useContext(UserContext);
  const { addToast } = useContext(ToasterContext);
  const [open, setOpen] = useState<boolean>(false);
  const [successOrderId, setSuccessOrderId] = useState<null | number>(null);
  const [orderNumber, setOrderNumber] = useState<number>(0);
  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [data, setData] = useState<any>([]);
  const [refetchState, setRefetchState] = useState(false);
  const refetch = () => {
    setRefetchState(!refetchState);
  };
  useEffect(() => {
    const api = `${process.env.REACT_APP_API_URL}/v2/order/get/openOrdersSeller?userId=${id}`;
    axios
      .get(api)
      .then((response) => {
        setLoading(false);
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [refetchState]);

  // const {data, loading: queryLoading, refetch } = useQueryOrders({
  //   variables: {
  //     where: {
  //       AND: [
  //         { sellerUserId: {equals: +id} },
  //         { isConfirmed: {equals: false }},
  //         { status: {equals: 1}},
  //       ]
  //     },
  //     orderBy: [ { createdAt: "desc" } ] },
  //   fetchPolicy: 'no-cache'
  // });

  const getData = (items: any) => {
    let newData: any = [];

    items.forEach((item: any) => {
      const foundOrderIndex = newData.findIndex(
        (dataItem: any) => dataItem.orderNumber === item.orderNumber
      );

      if (foundOrderIndex === -1) {
        newData.push({ ...item, totalAmount: `${Number(item.totalAmount)}` });
      } else {
        newData[foundOrderIndex].totalAmount = `${Number(
          newData[foundOrderIndex].totalAmount
        ) + Number(item.totalAmount)}`;
      }
    });

    // Sort by orderNumber descending so newest / largest numbers appear on top
    newData.sort((a: any, b: any) => {
      const aNum = Number(a.orderNumber);
      const bNum = Number(b.orderNumber);

      // Fallback to string compare if parsing fails
      if (Number.isNaN(aNum) || Number.isNaN(bNum)) {
        return String(b.orderNumber).localeCompare(String(a.orderNumber));
      }

      return bNum - aNum;
    });

    return newData;
  };

  const { data: bankAccount } = useQueryBankAccount({
    variables: {
      where: {
        AND: [{ object: { equals: "bank_account" } }, { userId: { equals: +id } }, { accountId: { not: { equals: null } } }],
      },
    },
    fetchPolicy: "no-cache",
  });

  // const search = useCallback(
  //   debounce(async (value: string) => {
  //     setLoading(true);
  //     let andQuery: any = [{ sellerUserId: { equals: +id } }, { isConfirmed: { equals: false } }, { status: { equals: 1 } }];

  //     if (value) {
  //       andQuery.push({
  //         orderNumber: {
  //           contains: value,
  //           mode: "insensitive",
  //         },
  //       });
  //     }

  //     await refetch({
  //       where: { AND: andQuery },
  //       orderBy: [{ createdAt: "desc" }],
  //     });
  //     setLoading(false);
  //   }, 1000),
  //   []
  // );

  // const handleSearch = (value: string) => {
  //   setSearchInput(value);
  //   search(value);
  // };

  return (
    <Paper sx={{ p: 4, display: "flex", flexDirection: "column", minHeight: "350px" }}>
      <Typography component="h1" variant="h5">
        Open Orders
      </Typography>
      <Grid container sx={{ mb: 2, marginTop: "32px" }}>
        {/* <Grid item xs={12} sm={12} md={8} xl={4}>
          <TextField
            type="text"
            placeholder={`Search by Order Number...`}
            value={searchInput}
            onChange={(event: any) => handleSearch(event.target.value)}
            fullWidth
            sx={{ minHeight: "30px", minWidth: "100%" }}
            size="small"
          />
        </Grid> */}
      </Grid>
      <Divider sx={{ borderWidth: "1px" }} />
      {loading ? (
        <CircularProgress sx={{ position: "absolute", left: "calc(150px + 50%)", top: "50%" }} color="inherit" />
      ) : (
        <>
          {data.length === 0 ? (
            <Box sx={{ mt: 10 }}>
              <Typography component="h1" variant="h5" sx={{ textAlign: "center" }}>
                No data
              </Typography>
            </Box>
          ) : (
            <Box sx={{ mt: 3 }}>
              {getData(data).map((item: any) => (
                <OrderItem
                  key={item.id}
                  item={item}
                  type={OrderType.openOrder}
                  action={(event: any) => {
                    event.stopPropagation();
                    if (bankAccount?.findFirstBankAccount) {
                      setOrderNumber(item.orderNumber);
                      setOpen(true);
                    } else {
                      addToast({ type: NotificationType.Error, title: "You are required to add your bank information before you can confirm order." });
                      navigate(routeConfigs.pharmacyProfile.path);
                    }
                  }}
                />
              ))}
              {open && <SellerConfirmationDialog open={open} setOpen={setOpen} data={data} orderNumber={orderNumber} setSuccessOrderId={setSuccessOrderId} refetch={refetch} />}
              {successOrderId !== null && <SuccessOrderDialog setSuccessOrderId={setSuccessOrderId} successOrderId={successOrderId} refetch={refetch} />}
            </Box>
          )}
        </>
      )}
    </Paper>
  );
};

export default OpenOrders;

